export const placeEnquiryEndpoints = {
  getInsuranceUsers: (userSubType: "SPOC" | "SURVEYOR") =>
    `/v1/users?userType=INSURANCE&userSubType=${userSubType}`,
  placeGaraazOrder: "/v1/orders",
  getXpressCustomer: (search: string) => `/v1/customers?search=${search}&isXpress=true`,
  searchXpressCustomer: `/v1/customers?isXpress=true&search=`,
  addMedia: "/media",
  deleteMedia: (mediaId: string) => `/media/${mediaId}`,
  mobileConfig: "/mobile/config",
  getCarMakers: () => "/v1/vehicle-tree/maker",
  getStateCity: "/utility/state-city",
  getInsurers: "/v1/customers/insurers",
  getBrands: "/v1/brands",
  getSearchedPartListBulk: (parts: { partNumber: string; orderedQuantity: number }[]) =>
    `/part/get-product-by-code-bulk/${parts.map((p) => p.partNumber).join(",")}`,
  getSearchedPartList: (partNumber: string) =>
    `/part/get-product-by-code/${encodeURIComponent(partNumber)}`,
};
